import { types, actions } from './requests'
export const GETRECENTCLIENTORDERLIST_TYPES = {
    ...types('GETRECENTCLIENTORDERLIST'),
}
export const GETRECENTCLIENTORDERLIST_ACTIONS = {
    ...actions('GETRECENTCLIENTORDERLIST'),
}
